// @ts-ignore
import * as Vue from 'vue';
var allVue = Vue;
var gh = allVue.h;
import { guid, noop, Keys, getTabIndex, validatePackage, isRtl } from '@progress/kendo-vue-common';
import { provideLocalizationService } from '@progress/kendo-vue-intl';
import { messages, switchValidation } from './../messages';
import { packageMetadata } from '../package-metadata';
var SWITCH_CONTAINER = 'k-switch-container';
var SWITCH_HANDLE = 'k-switch-handle';
var SWITCH_LABEL_ON = 'k-switch-label-on';
var SWITCH_LABEL_OFF = 'k-switch-label-off'; // tslint:enable:max-line-length

var Switch = {
  name: 'KendoSwitch',
  model: {
    event: 'changemodel'
  },
  // @ts-ignore
  emits: {
    'change': null,
    'changemodel': null,
    'update:modelValue': null,
    'focus': null,
    'blur': null
  },
  props: {
    accessKey: String,
    checked: {
      type: Boolean,
      default: undefined
    },
    className: String,
    disabled: {
      type: Boolean,
      default: false
    },
    defaultChecked: {
      type: Boolean,
      default: false
    },
    dir: String,
    id: String,
    ariaLabelledBy: String,
    ariaDescribedBy: String,
    offLabel: {
      type: String,
      default: 'OFF'
    },
    onLabel: {
      type: String,
      default: 'ON'
    },
    required: {
      type: Boolean,
      default: false
    },
    tabIndex: Number,
    valid: Boolean,
    // validate: {
    //     type: Boolean,
    //     default: false
    // },
    validityStyles: {
      type: Boolean,
      default: false
    },
    validationMessage: String,
    value: {
      type: [String, Number, Boolean],
      default: undefined
    },
    modelValue: {
      type: Boolean,
      default: undefined
    }
  },
  created: function created() {
    validatePackage(packageMetadata);
    this._id = guid();
    this.defaultValidationMessage = provideLocalizationService(this);
  },
  data: function data() {
    return {
      currentChecked: this.$props.defaultChecked,
      valueDuringOnChange: undefined,
      focused: false,
      currentDir: undefined
    };
  },
  computed: {
    computedValue: function computedValue() {
      return this.valueDuringOnChange !== undefined ? this.valueDuringOnChange : this.$props.checked !== undefined ? this.$props.checked : this.$props.value !== undefined ? this.$props.value : this.$props.modelValue !== undefined ? this.$props.modelValue : this.currentChecked;
    },
    switchClassName: function switchClassName() {
      var isValid = !this.validityStyles || this.validity().valid;
      return {
        'k-widget': true,
        'k-switch': true,
        'k-switch-on': this.computedValue,
        'k-switch-off': !this.computedValue,
        'k-state-focused': this.focused,
        'k-state-disabled': this.$props.disabled,
        'k-state-invalid': !isValid
      };
    }
  },
  mounted: function mounted() {
    this._element = this.v3 ? this.elementRef : this.$refs.element;
    this.input = this.v3 ? this.inputRef : this.$refs.input;
    this.currentDir = this.$props.dir !== undefined ? this.$props.dir : isRtl(this.$el) ? 'rtl' : 'ltr';
    this.setValidity();
  },
  updated: function updated() {
    this.setValidity();
  },
  // @ts-ignore
  setup: !gh ? undefined : function () {
    var v3 = !!gh;
    return {
      v3: v3
    };
  },
  // @ts-ignore
  render: function render(createElement) {
    var _this = this;

    var h = gh || createElement;
    var _a = this.$props,
        disabled = _a.disabled,
        id = _a.id,
        offLabel = _a.offLabel,
        onLabel = _a.onLabel,
        tabIndex = _a.tabIndex;
    return h("span", {
      "class": this.switchClassName,
      dir: this.currentDir,
      attrs: this.v3 ? undefined : {
        dir: this.currentDir
      },
      onKeydown: this.handleKeyDown,
      on: this.v3 ? undefined : {
        "keydown": this.handleKeyDown,
        "click": this.handleClick,
        "focusout": this.handleWrapperBlur,
        "focusin": this.handleWrapperFocus
      },
      onClick: this.handleClick,
      onFocusout: this.handleWrapperBlur,
      onFocusin: this.handleWrapperFocus
    }, [h("span", {
      "class": SWITCH_CONTAINER,
      id: id || this._id,
      attrs: this.v3 ? undefined : {
        id: id || this._id,
        role: 'switch',
        "aria-checked": this.computedValue,
        "aria-disabled": disabled || undefined,
        "aria-labelledby": this.$props.ariaLabelledBy,
        "aria-describedby": this.$props.ariaDescribedBy,
        tabIndex: getTabIndex(tabIndex, disabled, undefined),
        accessKey: this.$props.accessKey
      },
      role: 'switch',
      "aria-checked": this.computedValue,
      "aria-disabled": disabled || undefined,
      "aria-labelledby": this.$props.ariaLabelledBy,
      "aria-describedby": this.$props.ariaDescribedBy,
      ref: this.v3 ? function (el) {
        _this.elementRef = el;
      } : 'element',
      tabIndex: getTabIndex(tabIndex, disabled, undefined),
      accessKey: this.$props.accessKey
    }, [h("input", {
      type: "checkbox",
      attrs: this.v3 ? undefined : {
        type: "checkbox",
        tabIndex: -1,
        "aria-hidden": true
      },
      checked: this.v3 ? this.$props.checked : null,
      domProps: this.v3 ? undefined : {
        "checked": this.$props.checked,
        "value": this.computedValue
      },
      ref: this.v3 ? function (el) {
        _this.inputRef = el;
      } : 'input',
      tabIndex: -1,
      "aria-hidden": true,
      value: this.v3 ? this.computedValue : null,
      style: {
        opacity: 0,
        width: 1,
        border: 0,
        zIndex: -1,
        position: 'absolute',
        left: '50%'
      },
      onChange: noop,
      on: this.v3 ? undefined : {
        "change": noop
      }
    }), h("span", {
      "class": SWITCH_LABEL_ON
    }, [onLabel]), h("span", {
      "class": SWITCH_LABEL_OFF
    }, [offLabel]), h("span", {
      "class": SWITCH_HANDLE
    })])]);
  },
  methods: {
    focus: function focus() {
      if (this._element) {
        this._element.focus();
      }
    },
    element: function element() {
      return this._element;
    },
    name: function name() {
      return this.$props.name;
    },
    validity: function validity() {
      var customError = this.$props.validationMessage !== undefined;
      var isValid = this.$props.valid !== undefined ? this.$props.valid : !this.$props.required ? true : this.computedValue ? true : false;
      var valid = this.$props.valid !== undefined ? this.$props.valid : isValid;
      return {
        customError: customError,
        valid: valid,
        valueMissing: this.computedValue === null
      };
    },
    setValidity: function setValidity() {
      if (this.input && this.input.setCustomValidity) {
        this.input.setCustomValidity(this.validity().valid ? '' : this.$props.validationMessage || this.defaultValidationMessage.toLanguageString(switchValidation, messages[switchValidation]));
      }
    },
    limit: function limit(offset, drag, wrapper) {
      var wrapperWidth = wrapper.offsetWidth;
      var margin = drag.offsetWidth;

      if (offset < 0) {
        return 0;
      } else if (offset > wrapperWidth - margin) {
        return wrapperWidth - margin;
      }

      return offset;
    },
    toggle: function toggle(value, event) {
      this.currentChecked = value;
      this.valueDuringOnChange = value;
      this.$emit('change', {
        event: event,
        component: this,
        target: {
          value: value
        },
        name: this.$props.name,
        value: value,
        validity: this.validity()
      });
      this.$emit('changemodel', value);
      this.$emit('update:modelValue', value);
      this.valueDuringOnChange = undefined;
    },
    handleClick: function handleClick(event) {
      if (this.eventTimeStamp === event.timeStamp) {
        // This is guard against the case when wrapped in label, click event is emmited twice
        return;
      }

      this.eventTimeStamp = event.timeStamp;
      this.toggle(!this.computedValue, event);
    },
    handleKeyDown: function handleKeyDown(event) {
      if (this.$props.disabled) {
        return;
      }

      var keyCode = event.keyCode;

      if (keyCode === Keys.space || keyCode === Keys.enter) {
        this.toggle(!this.computedValue, event);
      }
    },
    handleWrapperFocus: function handleWrapperFocus(event) {
      if (this.$props.disabled) {
        return;
      }

      this.focused = true;
      this.$emit('focus', event);
    },
    handleWrapperBlur: function handleWrapperBlur(event) {
      if (this.$props.disabled) {
        return;
      }

      this.focused = false;
      this.$emit('blur', event);
    }
  }
};
var SwitchVue3 = Switch;
export { Switch, SwitchVue3 };